import { render, staticRenderFns } from "./SleepViewFullscreenWelcome.vue?vue&type=template&id=4f0c90a6&scoped=true"
import script from "./SleepViewFullscreenWelcome.vue?vue&type=script&lang=js"
export * from "./SleepViewFullscreenWelcome.vue?vue&type=script&lang=js"
import style0 from "./SleepViewFullscreenWelcome.vue?vue&type=style&index=0&id=4f0c90a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c90a6",
  null
  
)

export default component.exports